webpackJsonp([24,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(110),
	  /* template */
	  __webpack_require__(231),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'buttonDemo',
	  components: {
	    Btn: _btn2.default
	  },
	  created: function created() {
	    _eventbus2.default.$on('on-submit', function (msg) {
	      alert('触发表单' + msg);
	    });
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 231:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "p2222"
	  }, [_c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "size": "lg",
	      "theme": "primary-blank",
	      "block": "true",
	      "name": "普通操作"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "size": "lg",
	      "theme": "primary",
	      "block": "true",
	      "name": "普通操作2"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "size": "lg",
	      "theme": "warm",
	      "block": "true",
	      "name": "警告操作",
	      "icon": "safe"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "size": "lg",
	      "theme": "warm-blank",
	      "block": "true",
	      "name": "警告操作2",
	      "icon": "safe"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "theme": "primary",
	      "name": "按 钮"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "p1111"
	  }, [_c('btn', {
	    attrs: {
	      "size": "sm",
	      "theme": "primary",
	      "name": "按 钮"
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.ed172a8c4ea0b0e7c153.js